<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>

export default {
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange, false);
  },
  methods: {
    handleVisibilityChange() {
      if (document.hidden) {
        this.$Bus.$emit('visibility', false);
      } else {
        this.$Bus.$emit('visibility', true);
      }
    }
  }
}
</script>
<style lang="less">
html {
  font-size: (100vw / 3.75);
}

@media screen and (min-width: 600px) {
  html {
    font-size: 160px;
  }
}

body {
  font-size: 16px;
}

html,
body {
  position: relative;
  height: 100%;
  // overflow: hidden;
}

#app {
  width: 100%;
  height: 100%;
}
</style>
